import { ENDPOINT } from "../configs/api";
import { UserInfo } from "../types/user";
import { httpClient } from "./httpClient";
import { RequestResponse } from "../types/httpClient";

export async function getStudentInfo(): Promise<UserInfo | null> {
    const response: RequestResponse = await httpClient.get(ENDPOINT.iclass.studentInfo)
    if (response.data.code > 0) {
        return null
    }

    return response.data.results
}

export async function getTeacherInfo(): Promise<UserInfo | null> {
    const response: RequestResponse = await httpClient.get(ENDPOINT.iclass.teacherInfo)
    if (response.data.code > 0) {
        return null
    }

    return response.data.results
}